export const getFormattedDateString = (date) =>
  date ? new Date(date).toLocaleDateString('en-US') : '';
